export const isVoucher = (item) =>
  !!(item && item.itemType && item.itemType === "Voucher");

export const isSubscription = (item) =>
  !!(item && item.itemType && item.itemType === "Subscription");
